module.exports = __webpack_public_path__ + "static/media/ico-social02.b2597cf5.svg";